import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
    Accordion,
    Col,
    Button,
    ButtonGroup,
    InputGroup,
    Dropdown,
    Form,
    Row,
    Tab,
    Tabs,
    ListGroup,
    Table,
    Modal,
} from "react-bootstrap";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import {
    EMAIL_GET_SETTING,
    EMAIL_GET_TEMPLATE,
    EMAIL_SAVE_SETTING,
    EMAIL_SAVE_TEMPLATE,
    GLOBAL_FILE_UPLOAD_URL
} from "../../../../Constant/api";
import { authService } from "../../../../Service/Axios";
import { toast } from "react-toastify";
import { PreviewEmail } from "./PreviewEmail";
import { DEFAULT_MODULE_TYPE, FORMBUILDER_FILE_TYPES } from "Constant/constants";

const EmailTemplatePoc = () => {
    const { t } = useTranslation();
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [eleavailable, seteleavailable] = useState([]);
    const [openset, setopenset] = useState("");
    const [Type, setType] = useState("");
    const [emailsettings, setemailsettings] = useState(false)
    const [viewEmail, setviewEmail] = useState();
    const [viewSettingEmail, setviewSettingEmail] = useState();
    const [openCopy, setopenCopy] = useState(false)
    const [question, setquestion] = useState(viewSettingEmail?.questionName);
    const [border, setborder] = useState(viewSettingEmail?.boderwidth);
    const [right, setright] = useState(viewSettingEmail?.paddingright);
    const [left, setleft] = useState(viewSettingEmail?.paddingleft);
    const [bottom, setbottom] = useState(viewSettingEmail?.paddingbottom);
    const [top, settop] = useState(viewSettingEmail?.paddingtop);
    const [lnHeight, setlnHeight] = useState(viewSettingEmail?.lineheight);
    const [fntSize, setfntSize] = useState(viewSettingEmail?.fontsize);
    const [txtAlign, settxtAlign] = useState(viewSettingEmail?.textalign);
    const [txtColor, settxtColor] = useState(viewSettingEmail?.textcolor);
    const [bgColor, setbgColor] = useState(viewSettingEmail?.backgroundcolor);
    const [questID, setquestID] = useState(viewSettingEmail?.questionId);
    const [eleType, seteleType] = useState(viewSettingEmail?.elementType);
    const [seqNo, setseqNo] = useState(viewSettingEmail?.sequenceNo);

    const handleSettingData = (data) => {
        seteleavailable([
            ...eleavailable.filter((item) => item.questionId != data?.questionId),
            {
                questionId: eleavailable.filter((item) => item.questionId == data?.questionId)[0]?.questionId,
                questionName: question,
                label: "",
                placeholderText: null,
                fieldDescription: "",
                required: false,
                columnSpan: 0,
                sequenceNo: eleavailable.filter((item) => item.questionId == data?.questionId)[0]?.sequenceNo,
                typename: eleavailable.filter((item) => item.questionId == data?.questionId)[0]?.typename,
                controlNo: 0,
                controlType: "",
                cssname: "",
                value: [],
                buttonColor: "",
                buttonTextColor: "",
                readOnly: false,
                videoURL: "",
                imageURL: "",
                fontsize: fntSize,
                textalign: txtAlign,
                lineheight: lnHeight,
                textcolor: txtColor,
                backgroundcolor: bgColor,
                paddingtop: top,
                paddingbottom: bottom,
                paddingleft: left,
                paddingright: right,
                boderwidth: border
            },
        ]);
    }

    const handleDragDrop = (result) => {
        const { destination, source, draggableId } = result;

        if (!destination) return;

        if (draggableId == "text" || draggableId == "image" || draggableId == "button") {
            setopenset(draggableId);
            seteleavailable([
                ...eleavailable,
                {
                    questionId: Math.floor(100000 + Math.random() * 900000),
                    questionName: null,
                    label: "",
                    placeholderText: null,
                    fieldDescription: "",
                    required: false,
                    columnSpan: 0,
                    sequenceNo: eleavailable.length,
                    typename: draggableId,
                    controlNo: 0,
                    controlType: "",
                    cssname: "",
                    value: [],
                    buttonColor: "",
                    buttonTextColor: "",
                    readOnly: false,
                    videoURL: "",
                    imageURL: "",
                    fontsize: 0,
                    textalign: null,
                    lineheight: 0,
                    textcolor: null,
                    backgroundcolor: null,
                    paddingtop: null,
                    paddingbottom: null,
                    paddingleft: null,
                    paddingright: null,
                    boderwidth: null
                },
            ]);
        }
    };

    const htmls = `
    <!DOCTYPE html>
<html lang="en">

<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <title>Responsive Email Template</title>
    <style>
        /* General Styles */
        body, table, td, a {
            font-family: Arial, sans-serif;
            text-size-adjust: 100%;
            margin: 0;
            padding: 0;
        }
        table {
            border-collapse: collapse;
        }
        img {
            border: 0;
            height: auto;
            line-height: 100%;
            outline: none;
            text-decoration: none;
            display: block;
            max-width: 100%;
            height: auto;
        }
        a {
            color: inherit;
            text-decoration: none;
        }

        /* Mobile Styles */
        @media screen and (max-width: 640px) {
            .responsive-table {
                width: 100% !important;
            }
            .responsive-padding {
                padding: 10px 20px !important;
            }
            .mobile-hide {
                display: none !important;
            }
            .mobile-center {
                text-align: center !important;
            }
            .mobile-img {
                width: 100% !important;
                height: auto !important;
            }
        }
    </style>

    <style>
        .w-100 {
            width: 100%;
        }

        .h-100 {
            height: 100%;
        }

        .w-12 {
            width: 48px;
        }
        .h-12 {
            height: 48px;
        }
        .flex-auto {
            flex: 0 0 auto;
        }
        .me-2 {
            margin-right: 8px;
        }
        .d-flex {
            display: flex;
        }
        .justify-content-center {
            justify-content: center;
        }
        .align-items-center {
            align-items: center;
        }
        .text-white {
            color: #ffffff;
        }
        .rounded-circle {
            border-radius: 50%;
        }
        .bg-purple-600 {
            background-color: #6f42c1;
        }
        .overflow-hidden {
            overflow: hidden;
        }

        .new-avater {
            display: none;
        }


        .hover-effect {
            display: block;
            margin-bottom: 10px;
        }

        .position-relative {
            position: relative;
        }

        .text-grey-800 {
            color: #3a444c;
        }
        .text-decoration-none {
            text-decoration: none;
        }
        .text-sm {
            font-size: 14px;
        }
        .font-medium {
            font-weight: 500;
        }
        .text-nowrap{
            white-space: nowrap;
        }

        .hover-effect {
            font-size: 14px;
        }

    </style>
</head>

<body style="margin: 0; padding: 0;">
    <table border="0" cellpadding="0" cellspacing="0" width="100%" style="width:100%">
        <tbody>
            <tr>
                <td height="20">&nbsp;</td>
            </tr>
            <tr>
                <td>
                    <!-- Main Wrapper Table -->
                    <table border="0" cellpadding="0" cellspacing="0" width="100%" style="padding:20px">
                        <tr>
                            <td align="center" style="padding: 0 20px;">
                                <!-- Email Body -->
                                <table border="0" cellpadding="0" cellspacing="0" width="600" class="responsive-table" style="width:100%;background-color: #ffffff; padding: 20px;">
                                    <tr>
                                        <td align="left" class="responsive-padding" style="padding: 20px;">
                                            <table border="0" cellpadding="0" cellspacing="0" width="100%" class="responsive-table">
                                                <tbody>
                                                ${eleavailable?.map(item => {
        if (item.typename == "text") {
            return `<tr>
                                                                    <td>
                                                                        <p style="font-size: ${item.fontsize}px; text-align: ${item.textalign}; line-height: ${item.lineheight}px; color: ${item.textcolor}; padding-top: ${item.paddingtop}px; padding-left: ${item.paddingleft}px; padding-bottom: ${item.paddingbottom}px; padding-right: ${item.paddingright}px; background-color: ${item.backgroundcolor}; border: ${item.boderwidth}px solid;">
                                                                            <strong>${item.questionName}</strong>
                                                                        </p>
                                                                    </td>
                                                                </tr>`;
        } else if (item.typename == "image") {
            return `<tr>
                                                                    <td>
                                                                        <img src="${item.questionName}" style="text-align: ${item.textalign}; padding-top: ${item.paddingtop}px; padding-left: ${item.paddingleft}px; padding-bottom: ${item.paddingbottom}px; padding-right: ${item.paddingright}px; background-color: ${item.backgroundcolor}; border: ${item.boderwidth}px solid;" />
                                                                    </td>
                                                                </tr>`;
        } else if (item.typename == "button") {
            return `<tr>
                                                                    <td>
                                                                        <a href="#" style="font-size: ${item.fontsize}px; text-align: ${item.textalign}; line-height: ${item.lineheight}px; color: ${item.textcolor}; padding-top: ${item.paddingtop}px; padding-left: ${item.paddingleft}px; padding-bottom: ${item.paddingbottom}px; padding-right: ${item.paddingright}px; background-color: ${item.backgroundcolor}; border: ${item.boderwidth}px solid;">
                                                                            Button
                                                                        </a>
                                                                    </td>
                                                                </tr>`;
        }
    }).join('')}
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                    </table>
                </td>
            </tr>
            <tr>
                <td height="20">&nbsp;</td>
            </tr>
        </tbody>
    </table>
</body>
</html>
    `
    const createEmailAction = async (data) => {
        const payload = {
            gid: "",
            emailId: 5,
            emailName: "",
            archive: true,
            recyleBin: true,
            Template: true,
            Star: true,
            status: data,
            creationDate: "",
            lastDateChange: "",
            createdBy: "",
            desciption: "",
            lastChangeBy: "",
            type: htmls,
            questions: eleavailable
        }
        const response = await authService(EMAIL_SAVE_TEMPLATE, "POST", payload);
        if (response) {
            setviewEmail(response);
            viewEmailAction()
        }
    };

    const settingEmailAction = async () => {
        const payload = {
            elementType: eleType,
            questionId: questID,
            emailId: 5,
            label: "",
            questionName: question,
            sequenceNo: seqNo,
            videoURL: "",
            imageURL: "",
            fontsize: fntSize,
            textalign: txtAlign,
            lineheight: lnHeight,
            textcolor: txtColor,
            backgroundcolor: bgColor,
            paddingtop: top,
            paddingbottom: bottom,
            paddingleft: left,
            paddingright: right,
            boderwidth: border
        }
        handleSettingData(payload)
        const response = await authService(EMAIL_SAVE_SETTING, "POST", payload);
        if (response) {
            toast.success("Saved Setting!");
            setType(response.elementType);
            setemailsettings(false);
        }
    };

    const viewEmailAction = async () => {
        const payload = { emailId: 5 };
        const response = await authService(
            EMAIL_GET_TEMPLATE,
            "POST",
            payload
        );
        if (response) {
            setviewEmail(response);
            seteleavailable(response.questions)
        }
    }

    useEffect(() => {
        viewEmailAction();
    }, []);

    const viewSettingEmailAction = async (k) => {
        const payload = {
            emailId: 5,
            questionId: k,
            // elementType: elementType,
            // sequenceNo: sequenceNo,
        };
        const response = await authService(EMAIL_GET_SETTING, "POST", payload);
        if (response) {
            setquestion(response.questionName);
            setborder(response.boderwidth);
            setright(response.paddingright);
            setleft(response.paddingleft);
            setbottom(response.paddingbottom);
            settop(response.paddingtop);
            setlnHeight(response.lineheight);
            setfntSize(response.fontsize);
            settxtAlign(response.textalign);
            settxtColor(response.textcolor);
            setbgColor(response.backgroundcolor);
            setquestID(response.questionId)
            seteleType(response.elementType)
            setseqNo(response.sequenceNo)
        }
        setemailsettings(!emailsettings)
    };

    const linkURI = `http://localhost:3000/email/5`

    const handlelinkURI = (e) => {
        setopenCopy(!openCopy);
        navigator.clipboard.writeText(linkURI);
        toast.success("Copied Successfully!");
    };

    const handleSaveEmail = (e) => {
        e.preventDefault();
        createEmailAction("save");
        toast.success("Saved Successfully!");
    };

    const handlePublishEmail = () => {
        setopenCopy(!openCopy);
        createEmailAction("Published");
        toast.success("Published Successfully!");
    };

    const viewShow = () => {
        //createFormAction("preview");
        toast.error("Only saved email is available here");
        setShow(true);
    };

    const uploadFile = async (file) => {
        const fileParts = file.type.split("/");
        const fileType = fileParts[1];

        let fileSize = 0;
        if (FORMBUILDER_FILE_TYPES.includes(fileType)) {
            if (file.size < 1000000) {
                fileSize = Math.floor(file.size / 1000) + "KB";
            } else {
                fileSize = Math.floor(file.size / 1000000) + "MB";
            }
            const formData = new FormData();
            formData.append("file", file);
            formData.append("appType", DEFAULT_MODULE_TYPE.formBuilder);
            const response = await authService(
                GLOBAL_FILE_UPLOAD_URL,
                "POST",
                formData
            );
            if (response) {
                toast.success("Saved!");
                setquestion(response.url)
            }
        }
    };

    return (
        <main className="main overflow-hidden">
            <div className="formeditor-wrapper shadow-1 box-shadow-3">
                <div className="formeditor-header bg-white rounded-top d-flex justify-content-between align-items-center shadow-sm relative">
                    <Button variant="editorclose border-0 bg-transparent border">
                        <i className="bx bx-x bx-md"></i>
                    </Button>
                    <div className="headereditor-title border-start py-3 ps-3 w-100">
                        <h3>Weekly Report Progress Project “Almanax”</h3>
                        <div className="headereditor-sub-title d-flex align-items-center">
                            <i className="bx bx-folder bx-xs me-1"></i> Email{" "}
                        </div>
                    </div>
                    <div className="d-flex align-items-center">
                        <div className="unduredo-btns d-flex align-items-center py-3">
                            <Button variant="action btn-sm px-1">
                                <i className="bx bx-undo bx-sm"></i>
                            </Button>
                            <Button variant="action btn-sm px-1">
                                <i className="bx bx-redo bx-sm"></i>
                            </Button>
                        </div>
                        <div className="editor-action-btns ms-2 d-flex gap-2 align-items-center py-3 px-3">
                            <Button variant="gray-light btn-sm bx-sm view-btn" onClick={viewShow}>
                                <i className="bx bx-show-alt"></i>
                            </Button>
                            <Button variant="gray-light btn-sm" onClick={handleSaveEmail}>Save</Button>
                            <Button variant="primary btn-sm" onClick={handlePublishEmail}>Publish</Button>
                            {openCopy && (
                                <div className="p-3 border-0 dropdown-menu-custom shadow max-300">
                                    <form className="">
                                        <div className="mb-3">
                                            <label className="form-label" for="getlink">
                                                {t("common.label.getLink")}
                                            </label>
                                            <div className="gap-2 input-group">
                                                <input
                                                    aria-label="Recipient's username"
                                                    aria-describedby="basic-addon2"
                                                    id="getlink"
                                                    className="rounded-1 form-control form-control-sm bg-grey-600 text-grey-700"
                                                    value={linkURI}
                                                />
                                                <button
                                                    type="button"
                                                    className="btn btn-dark rounded-1"
                                                    onClick={handlelinkURI}
                                                >
                                                    {t("common.button.copy")}
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <DragDropContext onDragEnd={handleDragDrop}>
                    <div className="d-flex rounded-bottom overflow-hidden bg-white rounded-bottom-3 formbuilder-body">
                        <div className="w-20 px-2 py-4 bg-slate-50 border-end border-slate-200">
                            <div className="d-flex flex-column row-gap-4">
                                <button type="button" className="d-flex flex-column align-items-center row-gap-0 text-center border-0 bg-transparent text-slate-500">
                                    <span className="material-symbols-outlined">id_card</span>
                                    <span className="text-xs font-medium">Content</span>
                                </button>
                                <button type="button" className="d-flex flex-column align-items-center row-gap-0 text-center border-0 bg-transparent text-slate-500">
                                    <span className="material-symbols-outlined">settings</span>
                                    <span className="text-xs font-medium">Settings</span>
                                </button>
                                <button type="button" className="d-flex flex-column align-items-center row-gap-0 text-center border-0 bg-transparent text-slate-500">
                                    <span className="material-symbols-outlined">account_tree</span>
                                    <span className="text-xs font-medium">Condition</span>
                                </button>
                            </div>
                        </div>
                        <div className="formeditor-sidebar sidebar-left p-3 bg-white rounded-left-bottom-1 global-tab">
                            <Droppable droppableId="left_id">
                                {(provided, snapshot) => {
                                    return (
                                        <div ref={provided.innerRef} {...provided.droppableProps} className="drag-buttons d-inline-flex flex-wrap gap-2">
                                            <Draggable draggableId="text" index={0} key={1}>
                                                {(provided, snapshot) => (
                                                    <div {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        ref={provided.innerRef} className="btn btn-gray-light btn-sm border border-slate-300 d-flex align-items-center gap-1">
                                                        <span className="material-symbols-outlined align-middle text-md">notes</span> Text
                                                    </div>
                                                )}
                                            </Draggable>
                                            <Draggable draggableId="button" index={1} key={2}>
                                                {(provided, snapshot) => (
                                                    <div {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        ref={provided.innerRef} className="btn btn-gray-light btn-sm border border-slate-300 d-flex align-items-center gap-1">
                                                        <span className="pluto-button text-md"></span> Button
                                                    </div>)}
                                            </Draggable>
                                            <Draggable draggableId="image" index={2} key={3}>
                                                {(provided, snapshot) => (
                                                    <div {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        ref={provided.innerRef} className="btn btn-gray-light btn-sm border border-slate-300 d-flex align-items-center gap-1">
                                                        <span className="material-symbols-outlined">imagesmode</span> Image
                                                    </div>)}
                                            </Draggable>
                                        </div>);
                                }}
                            </Droppable>
                        </div>

                        <div className="formeditor-view ms-auto sidebar-right p-3 border-end border-start h-100">
                            <div className="p-3 rounded-2 bg-white border scroll-y">
                                <Droppable
                                    droppableId={`id`}
                                >
                                    {(provided, snapshot) => (
                                        <Row className="gy-4" ref={provided.innerRef}
                                            {...provided.droppableProps}>
                                            {eleavailable?.map((item, index, arr) => {
                                                return (
                                                    <Draggable
                                                        key={item.questionId}
                                                        draggableId={item.questionId?.toString()}
                                                        index={item?.sequenceNo}
                                                    >
                                                        {(provided) => (
                                                            <div
                                                                {...provided.draggableProps}
                                                                {...provided.dragHandleProps}
                                                                ref={provided.innerRef}
                                                            >
                                                                {item.typename == "text" && (
                                                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                                        <div className="pe-4 position-relative">
                                                                            <div className="drag-editor">
                                                                                <textarea name="" id="" className="form-control border border-slate-300 rounded-3" onChange={(e) => {
                                                                                    setquestion(e.target.value);
                                                                                }}
                                                                                    value={question ? question : item.questionName}></textarea>
                                                                            </div>
                                                                            <div className="position-absolute d-flex flex-column gap-2 drag-dit-delete-option">
                                                                                <button className="border border-slate-300 rounded-2 bg-slate-50 w-8 h-8 d-flex justify-content-center align-items-center" onClick={() => viewSettingEmailAction(item.questionId)}><span class="material-symbols-outlined">edit</span></button>
                                                                                <button className="border border-slate-300 rounded-2 bg-slate-50 w-8 h-8 d-flex justify-content-center align-items-center cursor-move"><span class="material-symbols-outlined">zoom_out_map</span></button>
                                                                                <button className="border border-slate-300 rounded-2 bg-slate-50 w-8 h-8 d-flex justify-content-center align-items-center"><span class="material-symbols-outlined">delete</span></button>
                                                                            </div>
                                                                        </div>
                                                                    </Col>
                                                                )}
                                                                {item.typename == "button" && (
                                                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                                        <div className="pe-4 position-relative">
                                                                            <div className="drag-editor">
                                                                                <div className="p-2 bg-white border rounded h-150">
                                                                                    <a href="#" style={{ display: "inline-block", padding: "10px 20px", fontSize: "16px", textDecoration: "none", color: "#ffffff", borderRadius: "6px", backgroundColor: "#3B3B3B" }}>Button</a>
                                                                                </div>
                                                                            </div>
                                                                            <div className="position-absolute d-flex flex-column gap-2 drag-dit-delete-option">
                                                                                <button className="border border-slate-300 rounded-2 bg-slate-50 w-8 h-8 d-flex justify-content-center align-items-center" onClick={() => viewSettingEmailAction(item.questionId)}><span className="material-symbols-outlined">edit</span></button>
                                                                                <button className="border border-slate-300 rounded-2 bg-slate-50 w-8 h-8 d-flex justify-content-center align-items-center cursor-move"><span className="material-symbols-outlined">zoom_out_map</span></button>
                                                                                <button className="border border-slate-300 rounded-2 bg-slate-50 w-8 h-8 d-flex justify-content-center align-items-center"><span className="material-symbols-outlined">delete</span></button>
                                                                            </div>
                                                                        </div>
                                                                    </Col>
                                                                )}
                                                                {item.typename == "image" && (
                                                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                                        <div className="pe-4 position-relative">
                                                                            <div className="drag-editor">
                                                                                <div className="file-input-box bg-white border rounded">
                                                                                    <img
                                                                                        src={question ? question : item.questionName}
                                                                                        alt=""
                                                                                        className="d-block rounded-2 img-fluid"
                                                                                    />

                                                                                    <label for="file" className="d-block p-5 text-center">
                                                                                        <span className="material-symbols-outlined">
                                                                                            image
                                                                                        </span>
                                                                                        <h5 className="mb-0 text-sm text-slate-500">
                                                                                            <strong className="font-semibold">Choose file</strong> or{" "}
                                                                                            <strong className="font-semibold">Drag here</strong>
                                                                                        </h5>
                                                                                        <small>File size limit 20 MB</small>
                                                                                    </label>
                                                                                    <input type="file" id="file" className="d-none" onChange={(e) => {
                                                                                        uploadFile(e.target.files[0]);
                                                                                    }} />
                                                                                </div>
                                                                            </div>
                                                                            <div className="position-absolute d-flex flex-column gap-2 drag-dit-delete-option">
                                                                                <button className="border border-slate-300 rounded-2 bg-slate-50 w-8 h-8 d-flex justify-content-center align-items-center" onClick={() => viewSettingEmailAction(item.questionId)}><span className="material-symbols-outlined">edit</span></button>
                                                                                <button className="border border-slate-300 rounded-2 bg-slate-50 w-8 h-8 d-flex justify-content-center align-items-center cursor-move"><span className="material-symbols-outlined">zoom_out_map</span></button>
                                                                                <button className="border border-slate-300 rounded-2 bg-slate-50 w-8 h-8 d-flex justify-content-center align-items-center"><span className="material-symbols-outlined">delete</span></button>
                                                                            </div>
                                                                        </div>
                                                                    </Col>
                                                                )}
                                                            </div>)}
                                                    </Draggable>
                                                );
                                            })}

                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                <div className="drag-drop-box py-5 px-3 d-flex justify-content-center align-items-center rounded-2 bg-light h-auto">
                                                    Drag and drop elements to build your email
                                                </div>
                                            </Col>
                                            {provided.placeholder}
                                        </Row>
                                    )}
                                </Droppable>
                            </div>
                        </div>

                        <div className="formeditor-sidebar ms-auto sidebar-right bg-white global-tab h-100">
                            {emailsettings && <div className="p-3 h-100 d-flex flex-column">
                                <div className="mb-2">
                                    <h3 className="text-base font-semibold text-slate-600">TItle settings</h3>
                                </div>
                                <div className="tab-content">
                                    <Row className="gy-4">
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                            <div className="mb-2 text-sm font-semibold text-slate-600">Font Size</div>
                                            <div>
                                                <select name="fontSize" id="" className="form-select text-sm" onChange={(e) => {
                                                    setfntSize(e.target.value);
                                                }}
                                                    value={fntSize}>
                                                    <option value="0"></option>
                                                    <option value="8">8</option>
                                                    <option value="10">10</option>
                                                    <option value="12">12</option>
                                                    <option value="14">14</option>
                                                    <option value="16">16</option>
                                                    <option value="18">18</option>
                                                    <option value="20">20</option>
                                                </select>
                                            </div>
                                        </Col>
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                            <div className="mb-2 text-sm font-semibold text-slate-600">Text align</div>
                                            <div>
                                                <div className="d-flex flex-wrap gap-2">
                                                    <input type="radio" class="btn-check" name="options" id="option1" checked={txtAlign == "left"} onChange={(e) => {
                                                        settxtAlign(e.target.value);
                                                    }}
                                                        value={"left"} />
                                                    <label class="btn btn-outline-slate" for="option1"><span class="material-symbols-outlined">format_align_left</span></label>

                                                    <input type="radio" class="btn-check" name="options" id="option2" checked={txtAlign == "center"} onChange={(e) => {
                                                        settxtAlign(e.target.value);
                                                    }}
                                                        value={"center"} />
                                                    <label class="btn btn-outline-slate" for="option2"><span class="material-symbols-outlined">format_align_center</span></label>

                                                    <input type="radio" class="btn-check" name="options" id="option3" checked={txtAlign == "right"} onChange={(e) => {
                                                        settxtAlign(e.target.value);
                                                    }}
                                                        value={"right"} />
                                                    <label class="btn btn-outline-slate" for="option3"><span class="material-symbols-outlined">format_align_right</span></label>
                                                </div>
                                            </div>
                                        </Col>

                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                            <div className="mb-2 text-sm font-semibold text-slate-600">Line height</div>
                                            <div>
                                                <select name="fontSize" id="" className="form-select text-sm" onChange={(e) => {
                                                    setlnHeight(e.target.value);
                                                }}
                                                    value={lnHeight}>
                                                    <option value="0"></option>
                                                    <option value="1">1</option>
                                                    <option value="2">2</option>
                                                    <option value="3">3</option>
                                                    <option value="4">4</option>
                                                    <option value="5">5</option>
                                                    <option value="6">6</option>
                                                    <option value="7">7</option>
                                                    <option value="8">8</option>
                                                    <option value="9">9</option>
                                                    <option value="10">10</option>
                                                </select>
                                            </div>
                                        </Col>

                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                            <Row>
                                                <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                                                    <div className="mb-2 text-sm font-semibold text-slate-600">Text color</div>
                                                    <div className="d-flex align-items-center gap-2">
                                                        <div className="flex-none w-9 h-9 rounded-2 border border-slate-300 bg-slate-100">
                                                            <input type="color" className="w-100 h-100 border border-slate-300 rounded-1" value={txtColor} onChange={e => settxtColor(e.target.value)} />
                                                        </div>
                                                        <div className="w-100 h-10 p-2 d-flex align-items-center text-sm text-slate-500 rounded-2 border border-slate-300 bg-slate-50">{txtColor}</div>
                                                    </div>
                                                </Col>
                                                <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                                                    <div className="mb-2 text-sm font-semibold text-slate-600">Background color</div>
                                                    <div className="d-flex align-items-center gap-2">
                                                        <div className="flex-none w-9 h-9 rounded-2 border border-slate-300 bg-slate-100">
                                                            <input type="color" className="w-100 h-100 border border-slate-300 rounded-1" value={bgColor} onChange={e => setbgColor(e.target.value)} />
                                                        </div>
                                                        <div className="w-100 h-10 p-2 d-flex align-items-center text-sm text-slate-500 rounded-2 border border-slate-300 bg-slate-50">{bgColor}</div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>

                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                            <div className="mb-2 text-sm font-semibold text-slate-600">Padding</div>
                                            <Row className="g-3">
                                                <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                                                    <div className="mb-2 text-xs font-semibold text-slate-600">Top</div>
                                                    <div class="input-group">
                                                        <input type="text" class="form-control" placeholder="0" onChange={(e) => {
                                                            settop(e.target.value);
                                                        }}
                                                            value={top} />
                                                        <span class="input-group-text" id="top">px</span>
                                                    </div>
                                                </Col>
                                                <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                                                    <div className="mb-2 text-xs font-semibold text-slate-600">Bottom</div>
                                                    <div class="input-group">
                                                        <input type="text" class="form-control" placeholder="0" onChange={(e) => {
                                                            setbottom(e.target.value);
                                                        }}
                                                            value={bottom} />
                                                        <span class="input-group-text" id="bottom">px</span>
                                                    </div>
                                                </Col>
                                                <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                                                    <div className="mb-2 text-xs font-semibold text-slate-600">Left</div>
                                                    <div class="input-group">
                                                        <input type="text" class="form-control" placeholder="0" onChange={(e) => {
                                                            setleft(e.target.value);
                                                        }}
                                                            value={left} />
                                                        <span class="input-group-text" id="left">px</span>
                                                    </div>
                                                </Col>
                                                <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                                                    <div className="mb-2 text-xs font-semibold text-slate-600">Right</div>
                                                    <div class="input-group">
                                                        <input type="text" class="form-control" placeholder="0" onChange={(e) => {
                                                            setright(e.target.value);
                                                        }}
                                                            value={right} />
                                                        <span class="input-group-text" id="right">px</span>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>

                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                            <Row>
                                                <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                                                    <div className="mb-2 text-sm font-semibold text-slate-600">Border width</div>
                                                    <div class="input-group">
                                                        <input type="text" class="form-control" placeholder="0" onChange={(e) => {
                                                            setborder(e.target.value);
                                                        }}
                                                            value={border} />
                                                        <span class="input-group-text" id="top">px</span>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </div>

                                <div className="mt-3 d-grid gap-2">
                                    <Button variant="green" onClick={settingEmailAction}>
                                        <i className="bx bx-save bx-sm align-middle"></i> Save Change
                                    </Button>
                                </div>
                            </div>}
                        </div>

                    </div>
                </DragDropContext>
            </div >
            {show && <PreviewEmail show={show} setShow={setShow} formId={5} htmls={htmls} />}
        </main >
    );
};

export default EmailTemplatePoc;
